import React from 'react'

import AppAdviceModal from '@/modules/dashboard/components/app-advice-modal/app-advice-modal'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

import store from '@/redux/store'
import { noMobileAdvice } from '@/modules/base/util/constants'

let currentCloseHandle = null

const openAppAdviceModal = () => {
  const { global: { useMobile }, subscription: { details: { subscriptions = [] } } } = store.getState()
  for (const route of noMobileAdvice) {
    if (location.pathname.startsWith(route)) {
      return
    }
  }

  // Check if renderElement is available
  if (typeof renderElement !== 'function') return

  const getComponent = (close) => {
    return !useMobile
      ? (
        <AppAdviceModal
          closeModal={() => {
            currentCloseHandle = null
            close()
          }}
          activeSubscriptions={subscriptions}
        />
      )
      : null
  }

  currentCloseHandle = renderElement(getComponent)
  return currentCloseHandle
}

export const closeAppAdviceModal = () => {
  if (currentCloseHandle) {
    currentCloseHandle()
    currentCloseHandle = null
  }
}

export default openAppAdviceModal
